import axios from "axios";

var hideAttribute = "d-none";

HTMLElement.prototype.dolj = function(){
    if(!this.classList.contains(hideAttribute)){
        this.classList.add(hideAttribute);
    }
};

HTMLElement.prototype.visa = function(){
    this.classList.remove(hideAttribute);
}

var skapaUtbildningsportratt = (function (){

    function initSkapaUtbildningsportratt() {

        var programContainerId = "program-container";
        var institutionContainerId = "institution-container";
        var namnContainerId = "namn-container";

        var programSelectList = document.getElementById("ValtProgram");

        var programContainer = document.getElementById(programContainerId);
        
        var institutionSelectList = document.getElementById("ValdInstitution");

        var institutionContainer = document.getElementById(institutionContainerId);
        
        var fakultetSelectList = document.getElementById("ValtFakultet");

        var submitKnappen = document.getElementById("skapa-utbildningsportratt-button");

        var namnContainer = document.getElementById(namnContainerId);

        var svensktNamn = document.getElementById("NamnSv");

        var engelsktNamn = document.getElementById("NamnEn");

        var error = document.getElementById("skapa-utbildningsportratt-error");

        var spinner = document.getElementById("skapa-utbildningsportratt-spinner");

        var buttonText = document.getElementById("skapa-utbildningsportratt-button-text");

        var formular = document.getElementById("skapa-utbildningsportratt-form");

        if (svensktNamn) {
            svensktNamn.addEventListener("input", function() {
                if(svensktNamn.value.trim().length > 0) {
                    error.dolj();
                }
            });
        }

        if (engelsktNamn) {
            engelsktNamn.addEventListener("input", function() {
                if(engelsktNamn.value.trim().length > 0) {
                    error.dolj();
                }
            });
        }

        if (submitKnappen){
            submitKnappen.addEventListener("click", function(event) {
                event.preventDefault();
                if(svensktNamn.value.trim().length === 0 && engelsktNamn.value.trim().length === 0) {
                    error.visa();
                    error.innerHTML = "<h3>Svenskt eller engelskt namn måste anges</h3>"
                } else {
                    spinner.classList.remove(hideAttribute);
                    submitKnappen.disabled = true;
                    buttonText.innerText = "Skapar ...";
                    formular.submit();
                }
            });
        }

        if (programSelectList) {
            programSelectList.addEventListener("change", function () {
                if (programSelectList.selectedIndex === 0) {
                    namnContainer.dolj();
                    institutionSelectList.disabled = false;
                } else {
                    namnContainer.visa();
                    institutionSelectList.disabled = true;
                }
            });
        }
        
        if (institutionSelectList) {
            institutionSelectList.addEventListener("change", function () {
                if(institutionSelectList.selectedIndex === 0) {
                    namnContainer.dolj();
                    programSelectList.disabled = false;
                } else {
                    namnContainer.visa();
                    programSelectList.disabled = true;
                }
            });
        }
        
        if (fakultetSelectList) {
            fakultetSelectList.addEventListener("change", function () {
                namnContainer.dolj();
                if(fakultetSelectList.selectedIndex === 0) {
                    programContainer.dolj();
                    aterstallSelectlist(programSelectList);
                    programSelectList.disabled = false;
                    institutionContainer.dolj();
                    aterstallSelectlist(institutionSelectList);
                    institutionSelectList.disabled = false;
                } else {
                    programSelectList.disabled = true;
                    institutionSelectList.disabled = true;
                    selectFakultet(fakultetSelectList.options[fakultetSelectList.selectedIndex].value);
                    programSelectList.disabled = false;
                    institutionSelectList.disabled = false;
                }
            });
        }

        function selectFakultet(fakultet) {
            hamtaProgramOchInstitutioner(fakultet).then((result) => {
                if(result && result.status === 200) {
                    if(result.data.program.length === 0 && result.data.institutioner.length === 0) {
                        namnContainer.visa();
                        programContainer.dolj();
                        institutionContainer.dolj();
                        return;
                    }
                    laddaProgram(result.data.program);
                    laddaInstitutioner(result.data.institutioner);
                }
            });
        }

        function laddaProgram(programs) {
            if(programSelectList) {
                tomSelectList(programSelectList);
                programs.forEach(program => {
                    programSelectList.appendChild(new Option(program.text, program.value));
                });
                programContainer.visa();
            }
        }

        function laddaInstitutioner(institutioner) {
            if(institutionSelectList){
                tomSelectList(institutionSelectList);
                institutioner.forEach(institution => {
                    institutionSelectList.appendChild(new Option(institution.text, institution.value));
                });
                institutionContainer.visa();
            }
        }
    
        function tomSelectList(selectList) {
            for(var i = selectList.length - 1; i >= 1; i--) {
                selectList.remove(i);
            }
        }

        function aterstallSelectlist(selectList) {
            selectList.selectedIndex = 0;
        }
    
        function hamtaProgramOchInstitutioner(fakultet){
            return axios.post("/ubnoy/umucmsapi/redigerasida/skapautbildningsportratt/programochinstitutioner?fakultet=" + fakultet);
        }
    }
    return {
        initSkapaUtbildningsportratt: initSkapaUtbildningsportratt,
      };
})();

export default skapaUtbildningsportratt;